import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Property, PropertyService } from 'taxtank-core';
import { NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AbstractSelectComponent } from '@shared/component/form-controls/select/abstract-select/abstract-select.component';
import { Observable } from 'rxjs';
import { PropertyAddFormDialogComponent } from '@client/shared/components/property/property-forms/property-add/property-add-form-dialog/property-add-form-dialog.component';

/**
 * Property select form control
 * @TODO Alex: create abstract select component with common logic for all select form controls (group, empty, etc.)
 */
@Component({
  selector: 'app-property-select',
  templateUrl: './property-select.component.html',
  styleUrls: ['./property-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PropertySelectComponent extends AbstractSelectComponent<Property> implements OnInit {
  protected dialog = inject(MatDialog);
  private propertyService = inject(PropertyService);

  @Input() emptyOptionLabel = 'All properties';
  @Input() emptyMessage = 'You haven\'t added any properties yet.';
  @Input() placeholder = 'Select property';
  @Input() label = 'Property';
  dialogComponent = PropertyAddFormDialogComponent;

  getOptions$(): Observable<Property[]> {
    return this.propertyService.getArray();
  }
}
